import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme) => {
  return {
    innerContainer: {
      position: 'relative',
      borderRadius: 30,
      padding: 30,
      backgroundColor: theme.palette.background.default,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  };
});

const DesignContainer = ({
  color,
  children,
  isPreview = true,
  rounded = true,
  sx,
}) => {
  const classes = useStyles({
    color,
    rounded,
    isPreview,
  });

  return <Box className={classes.innerContainer}>{children}</Box>;
};

export default DesignContainer;
